import { get, post, patch, remove, download } from '../../services/NetworkUtils'

const Service = {
  getList: async (params) => await get('/v1/report-enquiry', params),
  show: async (id, params) => await get(`/v1/report-enquiry/${id}`, params),
  getJobApplication: async (id) =>
    await get(`/v1/report-enquiry/${id}/job-application`),
  // Per-holding consent-flow config for the selected company — tells New
  // Enquiry whether HR must supply the candidate e-KTP (ektp_upload_process).
  getConsentConfig: async (params) =>
    await get('/v1/report-enquiry/consent-config', params),
  create: async (data) => await post('/v1/report-enquiry', data),
  // Per-enquiry payment preview: price + whether quota already covers it, so the
  // Confirm-payment step can show a price/method choice or "covered by quota".
  previewPayment: async (params) => await get('/v1/report-enquiry/preview', params),
  // HR uploads the candidate e-KTP + identity (multipart) for an enquiry that
  // is still awaiting_form (ektp_upload_process='hr' flow).
  uploadKtp: async (id, formData) =>
    await post(`/v1/report-enquiry/${id}/ktp`, formData, 'form-data'),
  // HR uploads a per-enquiry supporting document (job_application_form | terms_condition),
  // for an awaiting_form enquiry whose corresponding mode is 'hr'.
  uploadDocument: async (id, formData) =>
    await post(`/v1/report-enquiry/${id}/documents`, formData, 'form-data'),
  delete: async (body) => await remove('/v1/report-enquiry', body),
  getEmployees: async (params) =>
    await get('/v1/report-enquiry/employees', params),
  getEmployeeDetail: async (id, params) =>
    await get(`/v1/report-enquiry/employees/${id}`, params),

  // Export
  downloadExport: (params) => download('/v1/report-enquiry/export', params),

  // Actions
  cancel: async (id) => await patch(`/v1/report-enquiry/${id}/cancel`),
  resend: async (id) => await patch(`/v1/report-enquiry/${id}/resend`),
  reject: async (id, data) => await patch(`/v1/report-enquiry/${id}/reject`, data),
  submit: async (id) => await patch(`/v1/report-enquiry/${id}/submit`),
  refresh: async (id) => await patch(`/v1/report-enquiry/${id}/refresh`),
  revoke: async (id, data) => await patch(`/v1/report-enquiry/${id}/revoke`, data),
  uploadRevokeEvidence: async (formData) =>
    await post('/v1/report-enquiry/upload/revoke-evidence', formData, 'form-data'),

  // Options
  getCompanyOptions: async (params) =>
    await get('/v1/option/my-company-list', params),
  getLevelOptions: async (params) =>
    await get('/v1/settings/employment-level/levels', params),
  getPositionOptions: async (params) =>
    await get('/v1/settings/employment-level/positions', params),
}

export default Service
